import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Column, Dialog, Icon, OverlayTrigger, PopOver, Select, Table } from '@tencent/spaui';
import Cookies from 'js-cookie';
import { RPCFactory } from '../../../utils/RequestUtil';
import AddRule from './add-rule';

import useApp from '../../hooks/useApp';

import ABulkMiniDialog from '../businessSetting/ABulkMiniDialog';

import useDialog from '../../../leads_component/shared-components/hooks/useDialog';
import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';
import useConfirm from '../../../leads_component/shared-components/hooks/useContentDialog';

import { badgePrefix as prefix } from '../../../consts/prefix';

const Page = (props) => {
  const dialogHooks = useDialog({ showDialog: false });
  const [appList, setAppList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const { currentApp, setApp } = useApp({ uid: window.pageProps.uid });
  const [hasTag, setHasTag] = useState(false);
  const deleteConfirmHooks = useConfirm({ showDialog: false });

  const [campaignList, setCampaignList] = useState([]);
  const [adList, setAdList] = useState([]);
  const [target, setTarget] = useState(null);

  const tableHooks = useTable({
    deps: [currentApp, hasTag],
    getList: (setTableData, setTotal, curPage, pageSize) => {
      if (currentApp == '') {
        return Promise.resolve();
      }
      return RPCFactory.wechatRuleManagement
        .ruleList(currentApp, {})
        .done((data) => {
          setTableData(data.entities);
          setTotal(data.size);
        })
        .fail((status, msg) => {
          alert(msg ? msg : '请求失败');
        });
    },
  });

  useEffect(() => {
    Cookies.set(prefix + window.pageProps.uid, 'showed');
    RPCFactory.fansManagement.verifiedList().done((data) => {
      if (_.isArray(data) && data.length > 0) {
        setAppList(data);
        if (currentApp == '') {
          setApp(data[0].wxAppId);
        }
        setHasTag(true);
      } else {
        setHasTag(false);
      }
    });
  }, []);

  useEffect(() => {
    if (currentApp == '') {
      return;
    }
    RPCFactory.wechatTagManagement
      .userTagList(currentApp, {})
      .done((data) => {
        setTagList(data.entities);
      })
      .fail((code, msg) => {
        alert(msg);
      });

    RPCFactory.wechatRuleManagement.init(currentApp, {}).done((data) => {
      if (data) {
        setCampaignList(
          data.campaignList.map((item) => ({
            name: item.mpCampaignId,
            describe: item.campaignName,
            occupiedByOtherRules: item.occupiedByOtherRules,
          })),
        );
        setAdList(
          data.adgroupList.map((item) => ({
            name: item.mpAdId,
            describe: item.adName,
            occupiedByOtherRules: item.occupiedByOtherRules,
          })),
        );
      }
    });
  }, [currentApp]);

  const onDelete = () => {
    RPCFactory.wechatRuleManagement
      .delete(currentApp, {
        ruleId: deleteConfirmHooks.data.ruleId,
      })
      .done((data) => {
        deleteConfirmHooks.onClose();
        tableHooks.reloadTable();
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };
  const renderTag = (type, name, value, row) => {
    if (type == 'data') {
      const index = tagList.findIndex((ele) => ele.tagId == value);

      return index >= 0 ? tagList[index].tagName : value;
    }
    return value;
  };

  const genValueList = (type, idList) => {
    const title = type == 'campaign' ? '推广计划' : '广告';
    const mapList = type == 'campaign' ? campaignList : adList;

    if (!Array.isArray(idList)) {
      return '未知';
    }

    const nameList = [];
    idList.forEach((id) => {
      const index = mapList.findIndex((item) => item.name == id);

      if (index >= 0) {
        nameList.push(mapList[index].describe);
      }
    });

    return `${title}:${nameList.join(',')}`;
  };

  const renderFansSourceType = (type, name, value, row) => {
    if (type == 'data') {
      if (row.fansSourceType == 'Non_Ad') {
        return '非广告渠道';
      }
      if (row.fansSourceType == 'Ad') {
        const map = row.fansSourceDetail || {};
        if (map.mpCampaignId && Array.isArray(map.mpCampaignId)) {
          return genValueList('campaign', map.mpCampaignId);
        }
        if (map.mpAdId && Array.isArray(map.mpAdId)) {
          return genValueList('id', map.mpAdId);
        }
        return '未知';
      }
      return '未知';
    }
    return value;
  };
  const renderOp = (type, name, value, row) => {
    if (type == 'data') {
      return (
        <div>
          <a
            className="a-link-primary"
            onClick={(e) => {
              dialogHooks.showAsEditModel(row);
            }}
          >
            编辑
          </a>
          <a
            className="a-link-primary"
            onClick={(e) => {
              setTarget(e.target);
              deleteConfirmHooks.openDialog(row);
            }}
          >
            删除
          </a>
        </div>
      );
    }
    return value;
  };

  const renderContent = () => (
    <div className="datalist">
      <Table data={tableHooks.data}>
        <Column name="ruleName">规则名称</Column>
        <Column name="tagId" render={renderTag}>
          应用标签
        </Column>
        <Column name="fansSourceType" className="ColumnSource" render={renderFansSourceType}>
          渠道来源
        </Column>
        <Column name="op" render={renderOp}>
          操作
        </Column>
      </Table>
    </div>
  );
  const renderButton = () => {
    if (hasTag) {
      return (
        <Button
          displayType="primary"
          onClick={() => {
            dialogHooks.showAsAddModel();
          }}
        >
          <Icon type="add" />
          新建标签规则
        </Button>
      );
    }
    return (
      <OverlayTrigger
        trigger="hover"
        placement="right"
        overlay={<PopOver>暂无标签，请先在粉丝管理-标签管理新建标签</PopOver>}
      >
        <Button displayType="primary" disabled>
          <Icon type="add" />
          新建标签规则
        </Button>
      </OverlayTrigger>
    );
  };
  return (
    <main className="main" id="main">
      <div className="" style={{ position: 'relative' }}>
        <div className="a-tabs-head-right"  style={{ top: '-55px' }}>
          <div className="timely-tips">
            <span style={{ display: 'block', padding: '2px 4px 0 0' }}>所属公众号</span>
            <Select
              valueFieldName="wxAppId"
              labelFieldName="nickName"
              data={appList}
              value={currentApp}
              onChange={(e, value) => {
                setApp(value);
              }}
            />
          </div>
        </div>
        <div className="card">
          <div id="datarea" className="datarea">
            <div className="toolbars">
              <div className="toolbar table-toolbar">
                <div className="toolbar-left">
                  {renderButton()}
                  <span className="btn-tips">每个用户最多有20个标签，当用户已有20个标签时，无法生效新标签。</span>
                </div>
              </div>
            </div>
            {renderContent()}
          </div>
        </div>
        {dialogHooks.showDialog ? (
          <Dialog
            backdrop
            type="normal"
            className="modal-set-height"
            title={dialogHooks.contentProps.model == 'edit' ? '编辑' : '新建标签规则'}
            style={{ width: '1000px' }}
            {...dialogHooks.props}
            hideFooter
          >
            <AddRule
              {...dialogHooks.contentProps}
              tagList={tagList}
              wxAppId={currentApp}
              onSubmit={() => {
                dialogHooks.onSubmit();
                tableHooks.reloadTable();
              }}
              onCancel={() => {
                dialogHooks.onCancel();
              }}
            />
          </Dialog>
        ) : null}
        <ABulkMiniDialog
          show={deleteConfirmHooks.show}
          onSubmit={() => {
            onDelete();
          }}
          onCancel={deleteConfirmHooks.onClose}
          width={'280px'}
          eventTarget={target}
          eventTargetPlacement={'auto'}
          title={''}
        >
          <div className="confirmbox confirmbox-del">
            <div className="content">
              <p className="tt">确定删除此规则吗？</p>
              <p className="des">该规则删除后，粉丝关联的规则将自动更新。</p>
            </div>
          </div>
        </ABulkMiniDialog>
      </div>
    </main>
  );
};

export default Page;
